import { useContext as r } from "react";
import { NavbarContext as t } from "./context.js";
function n() {
  return r(t);
}
export {
  n as useNavbar
};
//# sourceMappingURL=useNavbar.js.map
